<template>
  <div class="pickup-label">
    <span class="label-text">
      <span
        v-if="message"
        class="label-bold"
        :style="{color: badgingColor}"
      >{{ message }}</span><span v-if="!noStore">at </span>
    </span>
    <button
      v-if="storeName && disabledPickupShowStore"
      aria-haspopup="dialog"
      :aria-label="ariaLabel"
      class="link-button store-button"
      @click.stop="handleChangeLocation"
    >
      <div v-if="storeName && disabledPickupShowStore">
        {{ storeName }}
      </div>
    </button>
    <p
      v-if="!storeName"
      class="no-store-selected"
    >
      Check your <button
        class="link-button"
        aria-label="select a store"
        @click.stop="handleChangeLocation"
      >
        local store
      </button> if you want it sooner.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PickupRadioLabelText',
  props: {
    message: {
      type: String,
      default: '',
    },
    noStore: {
      type: Boolean,
    },
    storeName: {
      type: String,
      default: '',
    },
    disabledPickupShowStore: {
      type: Boolean,
    },
    ariaLabel: {
      type: String,
    },
    badgingColor: {
      type: String,
      default: '',
    },
  },
  emits: ['changeLocation'],
  setup(_, { emit }) {
    const handleChangeLocation = () => {
      emit('changeLocation');
    };
    return {
      handleChangeLocation,
    };
  },
};
</script>
<style lang="scss" scoped>
.pickup-label {
  margin-right: rem-calc(5);
}

.label-bold {
  font-weight: 500;
}

.store-button {
  text-align: left;
  color: $black;
}

.no-store-selected {
  color: $black;
}
</style>
